export default __webpack_public_path__ + "static/media/University_of_Cambridge_crest_greyscale.8ee1774f.png";